import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 400, // 👈 Custom value for xs
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "'Inter'", // Define your preferred fonts
    // 🔧 override built-in variants
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },

    // ✅ custom variant
    body3: {
      fontSize: '1.25rem',
      fontWeight: 600,
      textTransform: 'uppercase',
    },
  },
});

export default theme;
